<app-casestudyicon *ngIf="name === 'icon'"></app-casestudyicon>